export const responseSuccess = (response, options) => {
  const newResponse = {
    response,
    data: {},
    headers: {},
    metadata: {}
  }

  if (response?.data?.data) newResponse.data = response?.data?.data

  if (response?.data?.metadata) newResponse.metadata = response?.data?.metadata

  if (options?.config?.headers) newResponse.headers = response?.headers

  return newResponse
}

export const responseError = (error) => {
  const newError = {}

  const { response } = error

  if (response?.data) {
    // eslint-disable-next-line no-console
    console.log('Log error data', response?.data)

    newError.error = response?.data
  }

  // eslint-disable-next-line no-console
  console.log('Log original error', error)

  return newError
}
